import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const BACKEND = process.env.REACT_APP_BACKEND;

const UpdateAchievement = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    heading: '',
    is_active: '1',
    image: ''
  });
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    const fetchOne = async () => {
      try {
        const res = await getRequest(`achievements/one/${id}`);
        const data = res?.data || {};
        const normalizedActive = data.is_active === 0 || data.is_active === '0' ? '0' : '1';
        setFormData({
          heading: data.heading || '',
          is_active: normalizedActive,
          image: data.image || ''
        });
      } catch (err) {
        console.error('Failed to fetch achievement:', err);
      }
    };
    fetchOne();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = new FormData();
    payload.append('heading', formData.heading || '');
    payload.append('is_active', formData.is_active || '1');
    if (imageFile) payload.append('image', imageFile);

    try {
      await patchRequest(`achievements/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Achievement updated successfully!');
      navigate('/achievements');
    } catch (error) {
      console.error('Failed to update achievement:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Update Achievement</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-sm-6 mt-2">
              <label className="admin-label" htmlFor="heading">Heading</label>
              <input
                id="heading"
                type="text"
                name="heading"
                className="form-control"
                value={formData.heading || ''}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-sm-3 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="is_active"
                className="form-control"
                value={formData.is_active || '1'}
                onChange={handleChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div className="col-sm-3 mt-2">
              <label className="admin-label" htmlFor="image">Image</label>
              <input
                id="image"
                type="file"
                className="form-control"
                onChange={(e) => setImageFile(e.target.files?.[0] || null)}
              />
            </div>
            <div className="col-sm-4 mt-2">
              {imageFile ? (
                <img
                  src={URL.createObjectURL(imageFile)}
                  alt="preview"
                  style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
                />
              ) : formData.image ? (
                <img
                  src={`${BACKEND}achievements/${formData.image}`}
                  alt="Current"
                  style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
                />
              ) : null}
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateAchievement;
